/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as editorCommon from '../common/editorCommon.js';
/**
 *@internal
 */
export function isCodeEditor(thing) {
  if (thing && typeof thing.getEditorType === 'function') {
    return thing.getEditorType() === editorCommon.EditorType.ICodeEditor;
  } else {
    return false;
  }
}
/**
 *@internal
 */
export function isDiffEditor(thing) {
  if (thing && typeof thing.getEditorType === 'function') {
    return thing.getEditorType() === editorCommon.EditorType.IDiffEditor;
  } else {
    return false;
  }
}
/**
 *@internal
 */
export function getCodeEditor(thing) {
  if (isCodeEditor(thing)) {
    return thing;
  }
  if (isDiffEditor(thing)) {
    return thing.getModifiedEditor();
  }
  return null;
}